function toText(value) {
  return String(value || '').trim();
}

function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

function firstText(...values) {
  return values.map((value) => toText(value)).find(Boolean) || '';
}

function addFieldLabel(map, value) {
  const item = resolveObject(value);
  const key = firstText(item.key, item.field_key);
  const label = firstText(item.label, item.title);
  if (key && label) {
    map.set(key, label);
  }
}

function buildFieldLabelMap(fieldDefinitions) {
  const map = new Map();
  resolveArray(fieldDefinitions).forEach((item) => addFieldLabel(map, item));
  return map;
}

function normalizeFieldRow(value, status, fieldLabelMap) {
  const item = resolveObject(value);
  const field = firstText(item.field_key, item.key, item.id, value);
  if (!field) {
    return null;
  }
  const label = firstText(item.label, item.title, fieldLabelMap.get(field), field);
  const displayValue = firstText(item.display_value, item.field_value, item.value);
  const fallbackValue = status === 'collected' ? '已确认' : '待补充';
  return {
    key: `${status}:${field}`,
    label,
    value: firstText(displayValue, fallbackValue),
    status,
  };
}

function candidateStatus(value) {
  const item = resolveObject(value);
  return firstText(item.status, item.state, 'candidate');
}

export function selectCanvasFieldRows(canvasState = {}) {
  const state = canvasState && typeof canvasState === 'object' && !Array.isArray(canvasState)
    ? canvasState
    : {};
  const collected = Array.isArray(state.collected) ? state.collected : [];
  const candidateFields = Array.isArray(state.candidate_fields) ? state.candidate_fields : [];
  const missing = Array.isArray(state.missing) ? state.missing : [];
  const fieldLabelMap = buildFieldLabelMap(state.field_definitions);
  const candidateKeys = new Set(candidateFields.map((item) => firstText(item?.field_key, item?.key)));
  return [
    ...collected.map((item) => normalizeFieldRow(item, 'collected', fieldLabelMap)),
    ...candidateFields.map((item) => normalizeFieldRow(item, candidateStatus(item), fieldLabelMap)),
    ...missing
      .filter((item) => !candidateKeys.has(firstText(item?.field_key, item?.key)))
      .map((item) => normalizeFieldRow(item, 'missing', fieldLabelMap)),
  ].filter(Boolean);
}

export default selectCanvasFieldRows;
